[
  {
    "id": "SWW-E7P-L206-001",
    "module": "SpellingWW",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "question": "Hij ... al een uur op de bus. (wachten)",
    "options": ["wacht", "wachtte", "heeft gewacht", "gewacht"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_geen_kofschip",
    "familyId": "SWW-TIJD-AL-EEN-UUR-WACHTEN",
    "conceptId": "vtdt_duur_context",
    "variantIndex": 1,
    "explanation": "Bij 'al een uur' klinkt het als: het begon eerder en geldt nog. Dan gebruik je voltooide tijd: heeft gewacht.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. Bij 'al een uur' past voltooide tijd beter.",
      "2": "Dit is verleden tijd en klinkt afgerond. De zin laat juist een duur zien.",
      "3": "Dit is alleen het voltooid deelwoord. Je mist het hulpwerkwoord."
    }
  },
  {
    "id": "SWW-E7P-L206-002",
    "module": "SpellingWW",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "question": "Zij ... haar tas toen ze vertrok. (vergeten)",
    "options": ["vergat", "vergeet", "vergeten", "heeft vergeten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_sterk",
    "familyId": "SWW-VT-STERK-VERGETEN",
    "conceptId": "vt_sterk_context",
    "variantIndex": 1,
    "explanation": "Door 'toen ze vertrok' weet je dat het verleden tijd is. 'Vergeten' is sterk. Enkelvoud verleden tijd: vergat.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. De context is duidelijk verleden.",
      "2": "Dit is het hele werkwoord. Je hebt een persoonsvorm nodig.",
      "3": "Dit is voltooide tijd, maar er staat geen 'had/heeft' passend in deze zin."
    }
  },
  {
    "id": "SWW-E7P-L206-003",
    "module": "SpellingWW",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "question": "De deur wordt ... (sluiten).",
    "options": ["gesloten", "gesloot", "sluit", "geslotene"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-LIJDENDE-VORM-SLUITEN",
    "conceptId": "passief_wordt_vd_sterk",
    "variantIndex": 1,
    "explanation": "Lijdende vorm: wordt + voltooid deelwoord. Van 'sluiten' is dat: gesloten.",
    "distractorExplanations": {
      "1": "Dit is geen juiste spelling van het voltooid deelwoord.",
      "2": "Dit is tegenwoordige tijd en past niet na 'wordt'.",
      "3": "Dit is een bijvoeglijke vorm die je hier niet nodig hebt."
    }
  },
  {
    "id": "SWW-E7P-L206-004",
    "module": "SpellingWW",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "question": "De ... kinderen speelden buiten. (lachen)",
    "options": ["lachende", "gelachte", "lachend", "lachte"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bn_vd",
    "familyId": "SWW-TD-LACHEN",
    "conceptId": "tegenwoordig_deelwoord_bijvoeglijk",
    "variantIndex": 1,
    "explanation": "Je beschrijft de kinderen terwijl ze spelen. Dan gebruik je het tegenwoordig deelwoord als bijvoeglijk: lachend. Bij meervoud komt er -e bij: lachende.",
    "distractorExplanations": {
      "1": "Dit is voltooid deelwoord en past niet bij iets dat tegelijk gebeurt.",
      "2": "Dit mist de -e bij meervoud: lachende kinderen.",
      "3": "Dit is verleden tijd, geen beschrijving."
    }
  }
]
